import { FLOAT_NUM_WITH_NEG_REGEX,FLOAT_NUM_REGEX,INT_NUM_REGEX,INT_NUM_WITH_NEG_REGEX } from '../core/model/fn-form.constant';


/**
 * method to get Percentage 
 * @param min number
 * @param max number
 * @param value number
 * @returns number value 
 */
export function getPercent(min: number, max: number, value: number): number {
  return ((value - min) / (max - min)) * 100;
}

/**
 * method to get number of decimal digit in a number
 * @param num value from which no. of digit to find. 
 * @returns no. of decimal digit present in number 
 */
export function getPrecision(num: number): number {
  const numStr = num.toString();
  const dotIndex = numStr.indexOf('.');
  return dotIndex >= 0 ? numStr.length - dotIndex - 1 : 0;
}

/**
 * method to return passed value only if it is number and  lies in between max and minimum number.
 * Otherwise return min if smaller then min num or return max if greater then max number.
 * @param num value which to ensure in give range.
 * @param min minimum value that method should return if num is samller then min.
 * @param max maximum value that method should return if num is greater then max.
 * @returns either num or min number or max number.
 */
export function ensureNumberInRange(num: number, min: number, max: number): number {
  if (isNaN(num) || num < min) {
    return min;
  } else if (num > max) {
    return max;
  } else {
    return num;
  }
}
/**
 * method to check passed string is vaid negative float number or not.
 * @param num string value to check.
 * @returns true if valid negative float number.
 */
export function isNegativeFloat(num : string){
  return FLOAT_NUM_WITH_NEG_REGEX.test(num);
}
/**
 * method to check passed string is vaid positive float number or not.
 * @param num string value to check.
 * @returns true if valid positive float number.
 */
export function  isPositiveFloat(num:string){
  return FLOAT_NUM_REGEX.test(num);
}
/**
 * method to check passed string is vaid Integer float number or not.
 * @param num string value to check.
 * @returns true if valid positive Integer number.
 */
export function isPostiveInteger(num:string){
  return INT_NUM_REGEX.test(num);
}
/**
 * method to check passed string is vaid negative Integer number or not.
 * @param num string value to check.
 * @returns true if valid negative Integer number.
 */
export function isNegativeInteger(num:string){
  return INT_NUM_WITH_NEG_REGEX.test(num);
}